import {permissionActions} from '../actions';

export default function permissions(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case permissionActions.SET_USER_PERMISSIONS: return setUserPermissions(newState, action);
        default: return newState;
    }
}

function setUserPermissions(newState, action) {
    delete action.type;
    newState = Object.assign(newState, {...action});
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/permissions.js